"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TABLE_STRIPE_TEAM_BLOCKS = void 0;
exports.TABLE_STRIPE_TEAM_BLOCKS = "stripe_team_blocks";
